import * as React from 'react'

import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import i18n from 'modules/core/lib/i18n'

const Sidebar = () => {
  const title = i18n.t('app_store_v2.common.sidebar.title')

  return (
    <PanesPadForm direction="vertical" compact>
      <PanesHeader
        title={title}
        description={i18n.t('app_store_v2.common.sidebar.description')}
        size="large"
      />
      {/* We don't want to show anything AT THE MOMENT */}
      <span />
    </PanesPadForm>
  )
}

export default Sidebar
